import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import Overview from "../components/Overview";

const OverviewPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title='Overview Page' />

        {/* BlankPageLayer */}
        <Overview />
      </MasterLayout>
    </>
  );
};

export default OverviewPage;
